import { useCallback, useEffect } from "react";

import useService from "../../../../hooks/useService";
import { useEntityAssociationsStore } from "../store/entityAssociationsStore";

const normalizeEntity = (entity) => ({
  id: entity?.id,
  name: entity?.name ?? "-",
  entityId: entity?.id ?? "-",
  entityTypes: [entity?.entityTypeLabel],
  einNumber: entity?.einNumber ?? "",
  locationCount: entity?.locationCount ?? 0,
});

export default function useEntityAssociationsData(entityId) {
  const entityRepository = useService("repositories/entity-repository");
  const { currentPage, resLimit, setData, setLoading, setResultCount } =
    useEntityAssociationsStore();

  const fetchEntityAssociationsData = useCallback(async () => {
    if (!entityId) {
      return;
    }

    setLoading(true);
    try {
      const offset = (currentPage - 1) * resLimit;
      const response = await entityRepository.getRelatedEntities(entityId, {
        limit: resLimit,
        offset,
      });
      setData((response || []).map(normalizeEntity));
      setResultCount((await entityRepository.getTotalCount()) || 0);
    } finally {
      setLoading(false);
    }
  }, [currentPage, entityId, entityRepository, resLimit, setData, setLoading, setResultCount]);

  useEffect(() => {
    fetchEntityAssociationsData();
  }, [fetchEntityAssociationsData]);

  return { fetchEntityAssociationsData };
}
